import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { hexdec } from '../../../components/shared/hexdec'
import { dechex } from '../../../components/shared/dechex'
import { database } from '../../../components/shared/database'

import type { DeviceEntity } from './parse-device-data'

interface DeviceData {
    address: string
    hint?: string
    data: string | number
    type?: string
}

interface EditValueProps {
    editDataModal: {
        device: DeviceEntity
        deviceData: DeviceData
    }
    onSuccess: () => void
}

/**
 * Inline form letting the user override a single device data field.
 *
 * Time fields are stored in their hex representation and rendered as
 * the human-readable decimal value.
 */
const EditValue = ({ editDataModal, onSuccess }: EditValueProps) => {
    const { t } = useTranslation()
    const [value, setValue] = useState('')

    const changeValue = (next: string): void => {
        setValue(editDataModal.deviceData.type === 'time' ? String(dechex(next)) : next)
    }

    useEffect(() => {
        changeValue(String(editDataModal.deviceData.data))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const saveValue = (): Promise<void> => {
        let resultValue: string | number = value

        if (editDataModal.deviceData.type === 'time') {
            resultValue = hexdec(value)
        }

        return database('device_writer')
            .add({
                ipAddress: editDataModal.device.ipAddress,
                deviceUid: editDataModal.device.uid,
                dbAddress: editDataModal.deviceData.address,
                dbValue: resultValue,
            })
            .then(() => onSuccess())
    }

    return (
        <div className="p-3">
            <div className="form-row d-flex flex-row flex-wrap align-items-end">
                <div className="form-group col-md-6 col-12">
                    <label htmlFor="input-element">
                        {t(`deviceData.hint.${editDataModal.deviceData?.hint}`)}
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        id="input-element"
                        value={value}
                        onChange={event => changeValue(
                            editDataModal.deviceData.type === 'time'
                                ? String(hexdec(event.target.value))
                                : event.target.value,
                        )}
                    />
                </div>
                <div className="form-group col-md-6 col-12">
                    <div className="btn btn-success" onClick={saveValue}>
                        {t('device.form.save')}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditValue
